module.exports = __webpack_public_path__ + "static/img/caseab.2ad707b2.png";